module.exports = __webpack_public_path__ + "img/kv.48606d2c.png";